<template>
  <div class="error-modal" @click.esc="close">
    <div class="error-modal-body">
      <div class="error-img">
        <img src="@/assets/icon/error.png" alt="" />
      </div>
      <div class="error-error">
        <p>{{ errorMessage }}</p>
      </div>
      <div class="error-close">
        <input type="button" @click="close" value="OK" class="error-btn" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["errorMessage"],
  methods: {
    close() {
      this.$emit("hideErrorMessage");
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.error-btn {
  background: #f2575d;
  color: white;
  width: 20%;
  text-align: center;
  align-items: center;
  height: 28px;
  border: 0;
}
.error-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}
.error-modal-body {
  position: absolute;
  top: 30%;
  width: 465px;
  height: 140px;
  border-radius: 5px;
  border: 1px solid #f8c3c5;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  background: #fffafa;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 10px;
}

.error-modal-body .error-error {
  font-size: 13px;
  width: 100%;
  line-height: 1.38;
  flex: 5;
  height: 30px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.error-img img {
  width: 40px !important;
}
.error-error p {
  text-align: center;
  font-size: 16px;
  color: #f2575d;
  line-height: 1em;
  width: 100%;
}
.error-modal-body div p {
  margin: 0;
}
.error-modal-body .error-img {
  text-align: center;
  height: 30px;
  flex: 0.5;
  line-height: 1.38;
}
.error-modal-body .error-close {
  width: 100%;
  height: 30px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.error-modal-body img {
  width: 100%;
  cursor: pointer;
}
.error-modal-body .error-message-icon {
  margin-top: 37px;
  height: 49px;
  flex: 0.8;
  font-size: 38px;
  color: #fff;
  padding-left: 24px;
  display: flex;
  justify-content: flex-end;
}
.error-modal-body .error-message-btn {
  margin-top: 25px;
  height: 49px;
  flex: 0.8;
  font-size: 18px;
  color: #fff;
  padding-right: 18px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
@media screen and (max-width: 500px) {
  .error-modal-body {
    margin-top: 80%;
  }
}
@media screen and (max-width: 800px) {
  .error-modal-body {
    margin-top: 30%;
    width: 90%;
  }
}
</style>